module.exports = __webpack_public_path__ + "static/img/svip-rs-bg.7849a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/svip-rs-bg.png
// module id = Ii8V
// module chunks = 28